import React from "react";

const base = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const MailIcon: React.FC = () => (
  <svg {...base}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

export const LockIcon: React.FC = () => (
  <svg {...base}>
    <rect x="4" y="11" width="16" height="9" rx="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" />
  </svg>
);

export const UserIcon: React.FC = () => (
  <svg {...base}>
    <circle cx="12" cy="8" r="4" />
    <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
  </svg>
);

export const PhoneIcon: React.FC = () => (
  <svg {...base}>
    <path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L16 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z" />
  </svg>
);

export const BriefcaseIcon: React.FC = () => (
  <svg {...base}>
    <rect x="3" y="8" width="18" height="12" rx="2" />
    <path d="M9 8V6a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
  </svg>
);

export const KeyIcon: React.FC = () => (
  <svg {...base}>
    <circle cx="8" cy="12" r="4" />
    <path d="M12 12h9M17 12v4M21 12v3" />
  </svg>
);

export const EyeIcon: React.FC = () => (
  <svg {...base}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export const EyeOffIcon: React.FC = () => (
  <svg {...base}>
    <path d="M9.9 4.2A10.9 10.9 0 0 1 12 4c6.5 0 10 7 10 7a16 16 0 0 1-3.2 3.9M6.1 6.1A16 16 0 0 0 2 11s3.5 7 10 7a10.9 10.9 0 0 0 4.2-.8" />
    <path d="m9.5 9.5a3 3 0 0 0 4.2 4.2M2 2l20 20" />
  </svg>
);

export const ArrowLeftIcon: React.FC = () => (
  <svg {...base} width={16} height={16}>
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
);
